import {
  MerchantChainConfigStatus,
  WalletSmartAccountType,
} from "@wallet-manager/node-types/dist/src/postgres/const";
import { isNil } from "lodash";
import { useState } from "react";
import { useQuery } from "react-query";
import { getWalletVersions } from "src/api/merchant";

function useQueryWalletVersion({
  chainType,
  walletTypes,
  chainId,
  smartAccountType,
  walletEnableStatus,
}: {
  chainType: number | undefined;
  chainId?: number;
  smartAccountType?: WalletSmartAccountType;
  walletEnableStatus?: MerchantChainConfigStatus;
  walletTypes?: (string | number)[];
}) {
  const [walletVersions, setWalletVersions] = useState<Record<string, string>>(
    {},
  );
  const [rawResponseList, setRawResponseList] = useState<any[] | undefined>(
    undefined,
  );

  const fetchWalletVersions = async () => {
    if (isNil(chainType)) {
      return;
    }

    return await getWalletVersions({
      chain_type: chainType,
      chain_id: chainId,
      smart_account_type: smartAccountType,
      wallet_types: walletTypes,
      status: walletEnableStatus,
    });
  };

  useQuery({
    queryKey: ["queryWalletVersions", chainType, chainId, walletTypes],
    queryFn: fetchWalletVersions,
    onSuccess: (res) => {
      if (!res) {
        setWalletVersions({});
        setRawResponseList([]);
        return;
      }
      setRawResponseList(res);

      const result = res.reduce((acc: Record<string, string>, cur) => {
        if (acc[cur.wallet_version]) {
          return acc;
        }

        return { ...acc, [cur.wallet_version]: cur.wallet_version };
      }, {});

      setWalletVersions(result);
    },
    enabled: !isNil(chainType),
  });

  return { walletVersions, rawResponseList };
}

export default useQueryWalletVersion;
